// MPX Service
export const MPX_SERVICE_MVATS = "MVATs Management UI";
export const MPX_SERIVCE_OPSUI = "Operations UI";
export const MPX_SERVICE_MVATS_PREVIEW = "MVATs Management UI - Preview";
export const MPX_SERIVCE_OPSUI_PREVIEW = "Operations UI - Preview";

// Hosts
// TODO: Hosts are hard coded for now, we might have to change in future
export const DEV_HOST = "vop.dev.vod.comcasttechnologysolutions.com";
export const TEST_HOST = "vop.staging.vod.comcasttechnologysolutions.com";
export const PROD_HOST = "vop.vod.comcasttechnologysolutions.com";
export const LOCALHOST = "localhost";

// Host strings
export const LOCAL = "Local";
export const DEV = "Dev";
export const PREVIEW = "Preview";
export const STAGING = "Staging";

// Service names
export const MVATS_WEB_SERVICE = "MVATs Web Service";
export const MVATS_TRANSFORMATION_SERVICE = "MVATs Transformation Service";
export const RULE_MGMT_DATA_SERVICE = "Rule Management Data Service";
export const VOD_SYCN_EVENT_DATA_SERVICE = "VOD Syndication Event Data Service";
export const VOD_SYCN_OFFERING_DATA_SERVICE =
  "VOD Syndication Offering Data Service";
export const VOD_SYCN_OFFERING_WEB_SERVICE =
  "VOD Syndication Offering Web Service";
export const VOD_SYCN_PREINGEST_DATA_SERVICE =
  "VOD Syndication Pre Ingest Data Service";
export const VOD_SYCN_PREINGEST_WEB_SERVICE =
  "VOD Syndication Pre Ingest Web Service";
export const VOD_SYCN_TEMPLATE_DATA_SERVICE =
  "VOD Syndication Template Data Service";

// Provider group account title prefix
export const POLARIS_ACCOUNT_TITLE_PREFIX_PREVIEW = "Polaris Preview ";
export const POLARIS_ACCOUNT_TITLE_PREFIX_PROD = "Polaris Production ";

// Misc
export const SECONDARY_OWNER_ANY = "cts:secondaryowner:any";

// Regular Expressions
export const REGEX_TITLE = /^[0-9a-zA-Z\s/_-]*$/i;
export const REGEX_DATE_FORMAT = /^[0-9a-zA-Z\s/':.-]*$/i;
export const REGEX_ENUM = /^[0-9a-zA-Z.\s_-{@}\/]*$/i;
export const REGEX_ISO8859_1 = /^[\x20-\x7E\xA0-\xA3\xA5\xA7\xA9-\xB3\xB5-\xB7\xB9-\xBB\xBF-\xFF\u20AC\u0160\u0161\u017D\u017E\u0152\u0153\u0178]*$/i;
// REF : https://www.regextester.com/94294



// WEBPACK FOOTER //
// ./src/Shared/constants.js